module.exports = __webpack_public_path__ + "static/spirit_troll-bf304873d8986048d3b4575544ce2766.png";